<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      lazy
      max-width="600px"
      transition="scale-transition"
    >
      <v-btn
        slot="activator"
        icon
      >
        <v-tooltip top>
          <template
            v-slot:activator="{ on }"
          >
            <v-icon
              v-on="on"
            >
              keyboard_arrow_down
            </v-icon>
          </template>
          <span>Mehr Details anzeigen</span>
        </v-tooltip>
      </v-btn>


      <v-card>
        <v-tabs
          v-model="activeTab"
          color="teal"
          fixed-tabs
          slider-color="yellow"
        >
          <v-tab class="pa-3">
            Inhalt
          </v-tab>
          <v-tab class="pa-3">
            Gastauftritte
          </v-tab>
          <v-tab class="pa-3">
            Fotos/Videos
          </v-tab>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card-text>
              <h3 class="episode__title">
                Folge {{ items.episode_number }} - {{ items.name }}
              </h3>
              <p class="episode__text">
                {{ items.overview }}
              </p>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="teal"
                flat
                small
                @click="dialog = false"
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              Gastauftritte folgt noch...
              <!-- <app-person-card :items="getPersonData" /> -->
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="teal"
                small
                flat
                @click="dialog = false"
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <p class="episode__text">
                Fotos/Videos folgen noch...
              </p>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="teal"
                small
                flat
                @click="dialog = false"
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import PersonOverview from '../PersonOverview.vue';
// import PersonCard from '../PersonCard.vue';

export default {
  name: 'EpisodeDetailsModal',
  components: {
    // appPersonOverview: PersonOverview,
    // appPersonCard: PersonCard,
  },
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      activeTab: null,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    modalState() {
      return this.$store.getters.detailsModal;
    },
    getPersonData() {
      let items;
      if (this.items.guest_stars.length > 0) {
        items = {
          people: this.items.guest_stars,
        };
      }
      return items;
    },
  },
  created() {
    // console.log('items:', this.items);
  },
  methods: {
    closeModal() {
      this.$store.commit('closeDetailsModal');
    },
  },
};
</script>

<style lang="scss" scoped>
.episode {
  &__title {
    width: 100%;
    font-weight: 300;
    margin-bottom: 15px;
    font-size: 20px;
    border-bottom: 1px solid #546e7a;
  }

  &__text {
    padding: 0px 5px;
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    text-align: justify;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  &__links {
    color: white;
    text-decoration: none;
  }
}
</style>
